import styled from "styled-components";

const StatsSection = styled.section`
  background-image: url(/assets/home/bar-background.png);
  background-position: center;
  padding: 40px 196px;
  box-sizing: border-box;
  overflow: hidden;
`;

const StatsContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-sizing: border-box;
  padding: 0 32px;
  gap: 50px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const StatsImage = styled.div`
  width: 402px;
  height: 324px;
  background-image: url(/assets/home/image-1.png);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0b0b0;
  font-size: 20px;
  flex-shrink: 0;
`;

const StatsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StatItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 24px 56px;
  height: 100%;
  white-space: nowrap;
  width: 200px;
`;

const StatCorner = styled.div`
  position: absolute;
  left: -20px;
  top: 0;
  width: 10px;
  height: 10px;
  background: #fd8616;
  border-radius: 2px;
`;

const StatNumber = styled.h2`
  font-size: 44px;
  color: #2640ed;
  display: inline-block;
`;

const StatUnit = styled.span`
  font-size: 16px;
  color: #2640ed;
  margin-left: 2px;
`;

const StatText = styled.p`
  font-size: 16px;
  color: #999999;
`;
const STATS_DATA = [
  { number: "6043080", text: "担保总额", unit: "万+" },
  { number: "298916", text: "担保业务", unit: "笔" },
  { number: "11854", text: "服务客户", unit: "家" },
  { number: "63", text: "入驻机构", unit: "家" },
];
export default function Stats() {
  return (
    <StatsSection>
      <StatsContainer>
        <StatsImage></StatsImage>
        <div>
          <StatsRow>
            {STATS_DATA.slice(0, 2).map((item, idx) => (
              <StatItem key={idx}>
                <StatCorner />
                <StatNumber>
                  {item.number}
                  {item.unit && <StatUnit>{item.unit}</StatUnit>}
                </StatNumber>
                <StatText>{item.text}</StatText>
              </StatItem>
            ))}
          </StatsRow>
          <StatsRow>
            {STATS_DATA.slice(2, 4).map((item, idx) => (
              <StatItem key={idx + 2}>
                <StatCorner />
                <StatNumber>
                  {item.number}
                  {item.unit && <StatUnit>{item.unit}</StatUnit>}
                </StatNumber>
                <StatText>{item.text}</StatText>
              </StatItem>
            ))}
          </StatsRow>
        </div>
      </StatsContainer>
    </StatsSection>
  );
}
